import { Link } from "react-router-dom";
import { ilshinGroupPhone } from "hooks/utils/util";
import logo_white from "assets/logo/logo_white.png";

const Footer = () => {
    return (
        <footer className="bg-[#2d3040] py-[35px] responsive1200:py-[20px] responsive1200:px-[4%]">
            <div className="max-w-[1200px] w-full flex justify-center items-center gap-[85px] mx-auto">
                <div className="flex flex-col">
                    <div className="text-white pb-[15px] text-[15px] flex gap-5">
                        <Link to="/policy/terms-conditions" className="py-[5px] hover:underline">
                            표준약관
                        </Link>
                        <Link to="/policy/privacy" className="py-[5px] hover:underline">
                            개인정보처리방침
                        </Link>
                    </div>
                    <div className="text-white/30 text-sm font-[400] flex flex-col gap-[5px] responsive1200:text-[13px] responsive1200:gap-0 responsive1200:leading-[18px]">
                        <p className="break-keep">
                            사업자명 : (주) 일신모닝택배 | 대표자 : 김대일 | 사업자등록번호 : 423-87-00238 | 대표전화 : 02-2661-4206 |
                            고객센터 :{ilshinGroupPhone("morning")} | 팩스 : 031-971-4208
                        </p>
                        <p>주소 : 경기도 고양시 덕양구 행주산성로 214 일신빌딩 | 이메일 : ilshinair@ilshinair.com</p>
                        <p>Copyright ⓒ 2020 (주) 일신모닝택배 All right reserved.</p>
                    </div>
                </div>
                <img className="animate-fade-in responsive1200:hidden" src={logo_white} alt="일신그룹" />
            </div>
        </footer>
    );
};

export default Footer;
